/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 *  The JSON representation for `NullValue` is JSON `null`.
 */
export enum GoogleProtobuf_NullValue {
  NULL_VALUE = 'NULL_VALUE',
}

export enum OdProtosCabinetData_Asset_Type {
  AUDIO = 'AUDIO',
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  UNKNOWN = 'UNKNOWN',
  VIDEO = 'VIDEO',
}

/**
 * Tribool is a boolean (Yes/No) with a third state (Maybe).
 */
export enum OdProtosCommonPagination_Tribool {
  MAYBE = 'MAYBE',
  NO = 'NO',
  YES = 'YES',
}

/**
 * Next ID: 66
 */
export enum OdProtosCommonState_State {
  AA = 'AA',
  AE = 'AE',
  AK = 'AK',
  AL = 'AL',
  AP = 'AP',
  AR = 'AR',
  AS = 'AS',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  PR = 'PR',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UNKNOWN = 'UNKNOWN',
  UT = 'UT',
  VA = 'VA',
  VI = 'VI',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY',
}

export enum OdProtosHomeworkData_LineItem_AccountCategory {
  BINSR = 'BINSR',
  RENOVATIONS = 'RENOVATIONS',
  REPAIRS = 'REPAIRS',
}

export enum OdProtosHomeworkData_LineItem_State {
  DRAFT = 'DRAFT',
  INVALID = 'INVALID',
  REWORK_REQUESTED = 'REWORK_REQUESTED',
  SCOPE_ACCEPTED = 'SCOPE_ACCEPTED',
  SCOPE_REJECTED = 'SCOPE_REJECTED',
  WORK_CANCELED = 'WORK_CANCELED',
  WORK_COMPLETED = 'WORK_COMPLETED',
  WORK_INVALIDATED = 'WORK_INVALIDATED',
  WORK_VALIDATED = 'WORK_VALIDATED',
}

export enum OdProtosHomeworkData_MessageThreadStatus {
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED',
  WAITING_ON_OPENDOOR_RESPONSE = 'WAITING_ON_OPENDOOR_RESPONSE',
  WAITING_ON_THIRD_PARTY_RESPONSE = 'WAITING_ON_THIRD_PARTY_RESPONSE',
}

export enum OdProtosHomeworkData_WorkOrder_Kind {
  FEEDBACK = 'FEEDBACK',
  HOA_VIOLATION = 'HOA_VIOLATION',
  HOLDING = 'HOLDING',
  INCIDENT = 'INCIDENT',
  INSURED = 'INSURED',
  LENDER_REQUIRED = 'LENDER_REQUIRED',
  LISTED = 'LISTED',
  LITE = 'LITE',
  LWOD = 'LWOD',
  MAINTENANCE = 'MAINTENANCE',
  MARKETPLACE = 'MARKETPLACE',
  OTHER = 'OTHER',
  PRELIMINARY = 'PRELIMINARY',
  REIT_RENOVATION = 'REIT_RENOVATION',
  RENOVATION = 'RENOVATION',
  RESALE = 'RESALE',
  REWORK = 'REWORK',
  SOLD = 'SOLD',
  TEST = 'TEST',
}

/**
 * When updating the Work Order State enum, also add it to the work_order_state enum in the db
 */
export enum OdProtosHomeworkData_WorkOrder_State {
  DRAFT = 'DRAFT',
  FINALIZED = 'FINALIZED',
  INVALID = 'INVALID',
  REWORK_REQUESTED = 'REWORK_REQUESTED',
  SCOPE_ACCEPTED = 'SCOPE_ACCEPTED',
  SCOPE_REJECTED = 'SCOPE_REJECTED',
  WORK_CANCELED = 'WORK_CANCELED',
  WORK_COMMENCED = 'WORK_COMMENCED',
  WORK_COMPLETED = 'WORK_COMPLETED',
  WORK_INVALIDATED = 'WORK_INVALIDATED',
  WORK_VALIDATED = 'WORK_VALIDATED',
}

export enum OdProtosIndextriousData_Filter_Operator {
  EQUALS = 'EQUALS',
  GEO_BOUNDING_BOX = 'GEO_BOUNDING_BOX',
  GEO_DISTANCE = 'GEO_DISTANCE',
  GEO_POLYGON = 'GEO_POLYGON',
  IN = 'IN',
  LIKE = 'LIKE',
  NOT_EQUALS = 'NOT_EQUALS',
  PHRASE_PREFIX = 'PHRASE_PREFIX',
  PREFIX = 'PREFIX',
  RANGE = 'RANGE',
}

export enum OdProtosIndextriousData_SortBy_Missing {
  FIRST = 'FIRST',
  LAST = 'LAST',
}

export enum OdProtosRefurbyData_MessageThreadStatus {
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED',
  WAITING_ON_OPENDOOR_RESPONSE = 'WAITING_ON_OPENDOOR_RESPONSE',
  WAITING_ON_THIRD_PARTY_RESPONSE = 'WAITING_ON_THIRD_PARTY_RESPONSE',
}

export enum OdProtosRollCallData_EnrollmentFilter_Column {
  ADDRESS_ID = 'ADDRESS_ID',
  ADDRESS_LABEL = 'ADDRESS_LABEL',
  ADDRESS_TSV = 'ADDRESS_TSV',
  CANCELLED_AT = 'CANCELLED_AT',
  DEFAULT_FIELD_USER_ID = 'DEFAULT_FIELD_USER_ID',
  MARKET_FENCE_ID = 'MARKET_FENCE_ID',
  SERVICE = 'SERVICE',
  VENDOR_BRANCH_ID = 'VENDOR_BRANCH_ID',
}

export enum OdProtosRollCallData_EnrollmentFilter_Operator {
  EQUAL_TO = 'EQUAL_TO',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  ILIKE = 'ILIKE',
  IN = 'IN',
  IS_NULL = 'IS_NULL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  LIKE = 'LIKE',
  TEXT_SEARCH = 'TEXT_SEARCH',
}

export enum OdProtosRollCallData_EnrollmentOrdering_Column {
  CANCELLED_AT = 'CANCELLED_AT',
  CREATED_AT = 'CREATED_AT',
}

/**
 * Deprecated
 */
export enum OdProtosRollCallData_Enrollment_Service {
  HOMEOPS_STANDARD = 'HOMEOPS_STANDARD',
  INVALID = 'INVALID',
  PROPERTY_MANAGEMENT = 'PROPERTY_MANAGEMENT',
}

/**
 * Next ID: 13
 */
export enum OdProtosTrippyData_VisitOrdering_Column {
  ADDRESS_ID = 'ADDRESS_ID',
  ASSIGNED_ORGANIZATION_ID = 'ASSIGNED_ORGANIZATION_ID',
  ASSIGNED_USER_TOKEN = 'ASSIGNED_USER_TOKEN',
  CANCELLED_AT = 'CANCELLED_AT',
  CHECK_IN_AT = 'CHECK_IN_AT',
  CHECK_OUT_AT = 'CHECK_OUT_AT',
  CREATED_AT = 'CREATED_AT',
  DUE_BY = 'DUE_BY',
  SCHEDULE_START_AT = 'SCHEDULE_START_AT',
  SCHEDULE_STOP_AT = 'SCHEDULE_STOP_AT',
  UPDATED_AT = 'UPDATED_AT',
  VISIT_TYPE_ID = 'VISIT_TYPE_ID',
}

/**
 * Next ID: 72
 * NOTE: When you update this, please also create a migration to update dwh_capabilities_view
 */
export enum OdProtosVendorsData_CapabilityType {
  AGENT = 'AGENT',
  APPLIANCE = 'APPLIANCE',
  BATHTUB_RESURFACING = 'BATHTUB_RESURFACING',
  BRN_AND_LRR = 'BRN_AND_LRR',
  BROKER = 'BROKER',
  CABINETS = 'CABINETS',
  CARPET_CLEANING = 'CARPET_CLEANING',
  CHIMNEY = 'CHIMNEY',
  CLEANING = 'CLEANING',
  CLEANING_MAINTENANCE = 'CLEANING_MAINTENANCE',
  CONCRETE_FLATWORK = 'CONCRETE_FLATWORK',
  COUNTERTOP = 'COUNTERTOP',
  COUNTERTOP_RESURFACING = 'COUNTERTOP_RESURFACING',
  CRAWL_SPACE = 'CRAWL_SPACE',
  DATA_LABELING = 'DATA_LABELING',
  DAY_ONE_WALK = 'DAY_ONE_WALK',
  DISPATCH = 'DISPATCH',
  ELECTRICAL = 'ELECTRICAL',
  ENGINEERING = 'ENGINEERING',
  FENCING = 'FENCING',
  FIREPLACE = 'FIREPLACE',
  FLOORING = 'FLOORING',
  FLOOR_REFINISHING = 'FLOOR_REFINISHING',
  FOUNDATION = 'FOUNDATION',
  GARAGE_DOOR = 'GARAGE_DOOR',
  GAS_LINE_SERVICE = 'GAS_LINE_SERVICE',
  GENERAL_CONTRACTOR = 'GENERAL_CONTRACTOR',
  GENERAL_INSPECTOR = 'GENERAL_INSPECTOR',
  GLASS_WINDOW = 'GLASS_WINDOW',
  GUTTERS = 'GUTTERS',
  HANDYMAN = 'HANDYMAN',
  HARDSCAPE_LANDSCAPE = 'HARDSCAPE_LANDSCAPE',
  HOME_ASSESSMENT = 'HOME_ASSESSMENT',
  HVAC = 'HVAC',
  IRRIGATION = 'IRRIGATION',
  JUNK_REMOVAL = 'JUNK_REMOVAL',
  LANDSCAPING_MAINTENANCE = 'LANDSCAPING_MAINTENANCE',
  LAND_SURVEYING = 'LAND_SURVEYING',
  LIVING_AREA_MEASUREMENT = 'LIVING_AREA_MEASUREMENT',
  LOCKSMITH = 'LOCKSMITH',
  MASONRY = 'MASONRY',
  MOLD_REMEDIATION = 'MOLD_REMEDIATION',
  ODOR_REMEDIATION = 'ODOR_REMEDIATION',
  OD_SELECT = 'OD_SELECT',
  OIL_TANK_SERVICES = 'OIL_TANK_SERVICES',
  PAINTING = 'PAINTING',
  PESTS = 'PESTS',
  PHOTOGRAPHY = 'PHOTOGRAPHY',
  PLUMBING = 'PLUMBING',
  POOL = 'POOL',
  POOL_REPAIR = 'POOL_REPAIR',
  PRESSURE_WASHING = 'PRESSURE_WASHING',
  RADON_TESTING = 'RADON_TESTING',
  RENO_VALUATIONS = 'RENO_VALUATIONS',
  RESTORATION = 'RESTORATION',
  ROOF = 'ROOF',
  SECURITY = 'SECURITY',
  SEPTIC = 'SEPTIC',
  SEWER_INSPECTIONS_AND_REPAIRS = 'SEWER_INSPECTIONS_AND_REPAIRS',
  SIDING = 'SIDING',
  SNOW = 'SNOW',
  STRUCTURAL = 'STRUCTURAL',
  TREE_SERVICES = 'TREE_SERVICES',
  VALUATIONS = 'VALUATIONS',
  WELLS = 'WELLS',
  WILDLIFE = 'WILDLIFE',
}

/**
 * Next ID: 2
 * NOTE: When you update this, please also create a migration to update dwh_compliance_view
 */
export enum OdProtosVendorsData_ComplianceStatus {
  COMPLIANT = 'COMPLIANT',
  NOT_COMPLIANT = 'NOT_COMPLIANT',
}

/**
 * Next ID: 3
 * NOTE: When you update this, please also create a migration to update dwh_branches_view
 */
export enum OdProtosVendorsData_Status {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING',
}

export enum OdProtosWebData_MaintenanceRequest_FrequencyKind {
  DAY = 'DAY',
  MONTH = 'MONTH',
  ONE_OFF = 'ONE_OFF',
  WEEK = 'WEEK',
}

export enum OdProtosWebData_MaintenanceRequest_Kind {
  CLEANING = 'CLEANING',
  HVAC = 'HVAC',
  LANDSCAPING = 'LANDSCAPING',
  NONE = 'NONE',
  OTHER = 'OTHER',
  POOL = 'POOL',
  SNOW = 'SNOW',
}

export enum OdProtosWebData_MaintenanceRequest_State {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  DENIED = 'DENIED',
  INVALID = 'INVALID',
  INVOICED = 'INVOICED',
  MISSED = 'MISSED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PENDING = 'PENDING',
}

/**
 * `ListValue` is a wrapper around a repeated field of values.
 *
 * The JSON representation for `ListValue` is JSON array.
 */
export interface GoogleProtobuf_ListValueInput {
  values?: GoogleProtobuf_ValueInput[] | null;
}

/**
 * `Struct` represents a structured data value, consisting of fields
 * which map to dynamically typed values. In some languages, `Struct`
 * might be supported by a native representation. For example, in
 * scripting languages like JS a struct is represented as an
 * object. The details of that representation are described together
 * with the proto support for the language.
 *
 * The JSON representation for `Struct` is JSON object.
 */
export interface GoogleProtobuf_StructInput {
  fields?: GoogleProtobuf_Struct_FieldsEntryInput[] | null;
}

/**
 * `GoogleProtobuf_Struct_FieldsEntryInput` represents the `fields` map in `google.protobuf.Struct`.
 */
export interface GoogleProtobuf_Struct_FieldsEntryInput {
  key?: string | null;
  value?: GoogleProtobuf_ValueInput | null;
}

/**
 * `Value` represents a dynamically typed value which can be either
 * null, a number, a string, a boolean, a recursive struct value, or a
 * list of values. A producer of value is expected to set one of these
 * variants. Absence of any variant indicates an error.
 *
 * The JSON representation for `Value` is JSON value.
 */
export interface GoogleProtobuf_ValueInput {
  kind?: GoogleProtobuf_Value_KindOneofInput | null;
}

export interface GoogleProtobuf_Value_KindOneofInput {
  nullValue?: GoogleProtobuf_NullValue | null;
  numberValue?: number | null;
  stringValue?: string | null;
  boolValue?: boolean | null;
  structValue?: GoogleProtobuf_StructInput | null;
  listValue?: GoogleProtobuf_ListValueInput | null;
}

export interface OdProtosCabinetData_AttachmentInput {
  major?: string | null;
  minor?: string | null;
  source?: string | null;
  assetId?: string | null;
}

/**
 * Sets the size modifier for photos.
 *
 * If both horizontal size and vertical size is unset, the raw image will be returned
 */
export interface OdProtosCabinetData_SizeModifierInput {
  name?: string | null;
  horizontalSize?: number | null;
  verticalSize?: number | null;
}

export interface OdProtosCabinetService_AssetRequests_CreateAssetInput {
  id?: string | null;
  name?: string | null;
  assetType?: OdProtosCabinetData_Asset_Type | null;
  fullPath?: string | null;
  source?: string | null;
  attachTo?: OdProtosCabinetData_AttachmentInput[] | null;
  public?: boolean | null;
  imageSizes?: OdProtosCabinetData_SizeModifierInput[] | null;
  highPriority?: boolean | null;
}

/**
 * Pagination request.
 *
 * To enable forward pagination, two arguments are required.
 * * first takes a non‐negative integer.
 * * after takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges after the after cursor, and returning at
 * most first edges.
 *
 * To enable backward pagination, two arguments are required.
 * * last takes a non‐negative integer.
 * * before takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges before the before cursor, and returning at
 * most last edges.
 */
export interface OdProtosCommonPagination_PaginationRequestInput {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
}

export interface OdProtosCommon_DateInput {
  year?: number | null;
  month?: number | null;
  day?: number | null;
}

export interface OdProtosHomeworkData_BidDetailsInput {
  scopes?: OdProtosHomeworkData_BidScopeInput[] | null;
}

export interface OdProtosHomeworkData_BidScopeInput {
  lineItemId?: string | null;
  description?: string | null;
  laborCost?: OdProtosHomeworkData_BidScope_LaborCostInput | null;
  materialCost?: OdProtosHomeworkData_BidScope_MaterialCostInput | null;
}

export interface OdProtosHomeworkData_BidScope_LaborCostInput {
  totalCents?: number | null;
  totalMinutes?: number | null;
}

export interface OdProtosHomeworkData_BidScope_MaterialCostInput {
  unitCents?: number | null;
  unitLabel?: string | null;
  quantity?: number | null;
}

/**
 * Only value aggregations are supported for now
 */
export interface OdProtosIndextriousData_AggregationInput {
  name?: string | null;
  field?: string | null;
  size?: number | null;
  subAggregations?: OdProtosIndextriousData_AggregationInput[] | null;
  topHits?: OdProtosIndextriousData_Aggregation_TopHitsInput | null;
}

export interface OdProtosIndextriousData_Aggregation_TopHitsInput {
  size?: number | null;
  sortBy?: OdProtosIndextriousData_SortByInput[] | null;
}

export interface OdProtosIndextriousData_FilterInput {
  value?: OdProtosIndextriousData_Filter_ValueOneofInput | null;
}

export interface OdProtosIndextriousData_Filter_AndFilterInput {
  filters?: OdProtosIndextriousData_FilterInput[] | null;
  name?: string | null;
}

export interface OdProtosIndextriousData_Filter_FieldExistsInput {
  value?: OdProtosIndextriousData_Filter_FieldExists_ValueOneofInput | null;
}

export interface OdProtosIndextriousData_Filter_FieldExists_ValueOneofInput {
  field?: string | null;
  nestedField?: string | null;
}

export interface OdProtosIndextriousData_Filter_FieldNotExistsInput {
  value?: OdProtosIndextriousData_Filter_FieldNotExists_ValueOneofInput | null;
}

export interface OdProtosIndextriousData_Filter_FieldNotExists_ValueOneofInput {
  field?: string | null;
  nestedField?: string | null;
}

export interface OdProtosIndextriousData_Filter_MultiFieldInput {
  fields?: string[] | null;
  operator?: OdProtosIndextriousData_Filter_Operator | null;
  operand?: OdProtosIndextriousData_Filter_OperandInput | null;
}

/**
 * NotFilter is a special case of AndFilter with only one filter.
 * It is used to negate the filter.
 */
export interface OdProtosIndextriousData_Filter_NotFilterInput {
  filters?: OdProtosIndextriousData_FilterInput[] | null;
  name?: string | null;
}

export interface OdProtosIndextriousData_Filter_OperandInput {
  value?: OdProtosIndextriousData_Filter_Operand_ValueOneofInput | null;
}

export interface OdProtosIndextriousData_Filter_Operand_ArrayValueInput {
  value?: string[] | null;
}

export interface OdProtosIndextriousData_Filter_Operand_GeoBoundingBoxValueInput {
  topLeft?: OdProtosIndextriousData_GeoPointInput | null;
  bottomRight?: OdProtosIndextriousData_GeoPointInput | null;
}

export interface OdProtosIndextriousData_Filter_Operand_GeoDistanceValueInput {
  distance?: string | null;
  origin?: OdProtosIndextriousData_GeoPointInput | null;
}

export interface OdProtosIndextriousData_Filter_Operand_GeoPolygonValueInput {
  vertices?: OdProtosIndextriousData_GeoPointInput[] | null;
}

export interface OdProtosIndextriousData_Filter_Operand_RangeValueInput {
  gte?: string | null;
  lte?: string | null;
  timeZone?: string | null;
}

export interface OdProtosIndextriousData_Filter_Operand_ValueOneofInput {
  stringValue?: string | null;
  arrayValue?: OdProtosIndextriousData_Filter_Operand_ArrayValueInput | null;
  rangeValue?: OdProtosIndextriousData_Filter_Operand_RangeValueInput | null;
  geoDistanceValue?: OdProtosIndextriousData_Filter_Operand_GeoDistanceValueInput | null;
  geoBoundingBoxValue?: OdProtosIndextriousData_Filter_Operand_GeoBoundingBoxValueInput | null;
  geoPolygonValue?: OdProtosIndextriousData_Filter_Operand_GeoPolygonValueInput | null;
}

export interface OdProtosIndextriousData_Filter_OrFilterInput {
  filters?: OdProtosIndextriousData_FilterInput[] | null;
  name?: string | null;
}

export interface OdProtosIndextriousData_Filter_SingleFieldInput {
  field?: string | null;
  operator?: OdProtosIndextriousData_Filter_Operator | null;
  operand?: OdProtosIndextriousData_Filter_OperandInput | null;
}

export interface OdProtosIndextriousData_Filter_ValueOneofInput {
  single?: OdProtosIndextriousData_Filter_SingleFieldInput | null;
  multi?: OdProtosIndextriousData_Filter_MultiFieldInput | null;
  exists?: OdProtosIndextriousData_Filter_FieldExistsInput | null;
  notExists?: OdProtosIndextriousData_Filter_FieldNotExistsInput | null;
  or?: OdProtosIndextriousData_Filter_OrFilterInput | null;
  and?: OdProtosIndextriousData_Filter_AndFilterInput | null;
  not?: OdProtosIndextriousData_Filter_NotFilterInput | null;
}

export interface OdProtosIndextriousData_GeoPointInput {
  lat?: number | null;
  lon?: number | null;
}

export interface OdProtosIndextriousData_PageParamsInput {
  number?: number | null;
  size?: number | null;
}

export interface OdProtosIndextriousData_SortByInput {
  field?: string | null;
  desc?: boolean | null;
  missing?: OdProtosIndextriousData_SortBy_Missing | null;
}

export interface OdProtosRollCallData_EnrollmentFilterInput {
  column?: OdProtosRollCallData_EnrollmentFilter_Column | null;
  operator?: OdProtosRollCallData_EnrollmentFilter_Operator | null;
  operand?: OdProtosRollCallData_EnrollmentFilter_OperandInput | null;
  isNegated?: boolean | null;
}

export interface OdProtosRollCallData_EnrollmentFilterSetInput {
  filters?: OdProtosRollCallData_EnrollmentFilterInput[] | null;
}

export interface OdProtosRollCallData_EnrollmentFilter_OperandInput {
  value?: OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneofInput | null;
}

export interface OdProtosRollCallData_EnrollmentFilter_Operand_StringListInput {
  strings?: string[] | null;
}

export interface OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneofInput {
  stringValue?: string | null;
  timestampValue?: GQLDateTime | null;
  stringValueList?: OdProtosRollCallData_EnrollmentFilter_Operand_StringListInput | null;
  serviceValue?: OdProtosRollCallData_Enrollment_Service | null;
}

export interface OdProtosRollCallData_EnrollmentOrderingInput {
  column?: OdProtosRollCallData_EnrollmentOrdering_Column | null;
  isAscending?: boolean | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosTrippyData_VisitOrderingInput {
  column?: OdProtosTrippyData_VisitOrdering_Column | null;
  isDescending?: boolean | null;
}

export interface OdProtosTrippyServices_TimestampParamInput {
  params?: OdProtosTrippyServices_TimestampParam_ParamsOneofInput | null;
}

export interface OdProtosTrippyServices_TimestampParam_ParamsOneofInput {
  unset?: boolean | null;
  timeRange?: OdProtosTrippyServices_TimestampRangeInput | null;
}

export interface OdProtosTrippyServices_TimestampRangeInput {
  start?: GQLDateTime | null;
  end?: GQLDateTime | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
